import { Component, OnDestroy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject } from 'rxjs';

import { WarningMessage } from 'app/core/services/launch-darkly/launch-darkly.types';

export interface ModalDialogData {
  title: string;
  text: string;
  primaryButtonText: string;
  secondaryButtonText?: string;
}
export enum ModalDialogResult {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  CLOSE = 'close',
}

@Component({
  selector: 'modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss'],
  standalone: false,
})
export class ModalDialogComponent implements OnDestroy {
  protected data = inject<ModalDialogData>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<ModalDialogComponent>>(MatDialogRef);

  public warningMessage?: WarningMessage;

  private destroyed$ = new ReplaySubject<boolean>(1);

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public onPrimaryClicked(): void {
    this.dialogRef.close(ModalDialogResult.PRIMARY);
  }

  public onSecondaryClicked(): void {
    this.dialogRef.close(ModalDialogResult.SECONDARY);
  }

  public closeDetail(): void {
    this.dialogRef.close(ModalDialogResult.CLOSE);
  }
}
